// Čísla s malou mezerou po tisících (české formátování, např. 12 345).
export const kc = (n) => (Number(n) || 0).toLocaleString("cs-CZ");

// Jednotková cena dle nejvyššího aplikovatelného množstevního tieru (jen pro zobrazení;
// autoritativní přepočet dělá server).
export function unitPriceFor(tiers, qty) {
  const applicable = tiers.filter((t) => t.min_quantity <= qty);
  if (!applicable.length) return tiers.length ? tiers[0].unit_price : 0;
  return applicable.reduce((a, b) => (b.min_quantity > a.min_quantity ? b : a)).unit_price;
}
